// src/pages/OnayAkisYonetimiPage.js
import React, { useState, useEffect, useCallback } from 'react';

const API = '';

const ONAYLAYAN_TURLER = [
  { deger: 'pozisyon_ustu', etiket: 'Org Hiyerarşisi (Üst Pozisyon)' },
  { deger: 'rol', etiket: 'Role Göre' },
  { deger: 'kullanici', etiket: 'Belirli Kişi' },
  { deger: 'modul', etiket: 'Modül Yetkisine Göre' },
];

// ROL_LISTESI artık DB'den çekiliyor

export default function OnayAkisYonetimiPage() {
  const [sablonlar, setSablonlar] = useState([]);
  const [kullanicilar, setKullanicilar] = useState([]);
  const [roller, setRoller] = useState([]);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [modalAcik, setModalAcik] = useState(false);
  const [secili, setSecili] = useState(null);
  const [hata, setHata] = useState('');
  const [basari, setBasari] = useState('');
  const [form, setForm] = useState({ talep_turu: '', baslik: '', aciklama: '', adimlar: [] });

  const token = localStorage.getItem('token');
  const headers = { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };

  const getir = useCallback(async () => {
    try {
      setYukleniyor(true);
      const [sabR, kulR, rolR] = await Promise.all([
        fetch(`${API}/api/onay/sablonlar`, { headers }),
        fetch(`${API}/api/personel-karti/liste/yoneticiler`, { headers }),
        fetch(`${API}/api/admin/roller-listesi`, { headers }),
      ]);
      const [sab, kul, rol] = await Promise.all([sabR.json(), kulR.json(), rolR.json()]);
      setSablonlar(Array.isArray(sab) ? sab : []);
      setKullanicilar(Array.isArray(kul) ? kul : []);
      setRoller(Array.isArray(rol) ? rol : []);
    } catch { setHata('Veriler yüklenemedi'); }
    finally { setYukleniyor(false); }
  }, []);

  useEffect(() => { getir(); }, [getir]);

  const yeniAc = () => {
    setSecili(null);
    setForm({ talep_turu: '', baslik: '', aciklama: '', adimlar: [{ sira: 1, baslik: '', onaylayan_tur: 'rol', onaylayan_deger: '', zorunlu: true, red_durumunda: 'iptal' }] });
    setHata(''); setBasari('');
    setModalAcik(true);
  };

  const duzenleAc = (sablon) => {
    setSecili(sablon);
    setForm({
      talep_turu: sablon.talep_turu,
      baslik: sablon.baslik,
      aciklama: sablon.aciklama || '',
      adimlar: (sablon.adimlar || []).map(a => ({ ...a, zorunlu: a.zorunlu === 1 }))
    });
    setHata(''); setBasari('');
    setModalAcik(true);
  };

  const adimEkle = () => {
    setForm(f => ({
      ...f,
      adimlar: [...f.adimlar, {
        sira: f.adimlar.length + 1,
        baslik: '',
        onaylayan_tur: 'rol',
        onaylayan_deger: '',
        zorunlu: true,
        red_durumunda: 'iptal'
      }]
    }));
  };

  const adimSil = (idx) => {
    setForm(f => ({
      ...f,
      adimlar: f.adimlar.filter((_, i) => i !== idx).map((a, i) => ({ ...a, sira: i + 1 }))
    }));
  };

  const adimGuncelle = (idx, alan, deger) => {
    setForm(f => ({
      ...f,
      adimlar: f.adimlar.map((a, i) => {
        if (i !== idx) return a;
        const updated = { ...a, [alan]: deger };
        // pozisyon_ustu seçilince onaylayan_deger otomatik set et
        if (alan === 'onaylayan_tur' && deger === 'pozisyon_ustu') {
          updated.onaylayan_deger = 'pozisyon_ustu';
        }
        return updated;
      })
    }));
  };

  const kaydet = async () => {
    if (!form.talep_turu || !form.baslik) { setHata('Talep türü ve başlık zorunludur'); return; }
    if (form.adimlar.length === 0) { setHata('En az bir onay adımı ekleyin'); return; }
    for (const a of form.adimlar) {
      if (!a.baslik || !a.onaylayan_deger) { setHata('Tüm adım alanlarını doldurun'); return; }
    }
    try {
      const url = secili ? `${API}/api/onay/sablonlar/${secili.id}` : `${API}/api/onay/sablonlar`;
      const method = secili ? 'PUT' : 'POST';
      const r = await fetch(url, { method, headers, body: JSON.stringify(form) });
      const d = await r.json();
      if (!r.ok) { setHata(d.hata || 'Hata oluştu'); return; }
      setBasari(d.mesaj);
      setTimeout(() => { setModalAcik(false); getir(); }, 800);
    } catch { setHata('Sunucu hatası'); }
  };

  const onaylayandegerSecenekleri = (tur) => {
    if (tur === 'pozisyon_ustu') return null;
    if (tur === 'rol') return roller.map(r => <option key={r.anahtar} value={r.anahtar}>{r.baslik}</option>);
    if (tur === 'kullanici') return kullanicilar.map(k => <option key={k.id} value={k.id}>{k.ad} {k.soyad}</option>);
    if (tur === 'modul') return [
      <option key="personel-listesi" value="personel-listesi">Personel Listesi Yetkisi</option>,
      <option key="izin-onay" value="izin-onay">İzin Onay Yetkisi</option>,
      <option key="masraf-yonetimi" value="masraf-yonetimi">Masraf Yönetimi Yetkisi</option>,
      <option key="zimmet-yonetimi" value="zimmet-yonetimi">Zimmet Yönetimi Yetkisi</option>,
    ];
    return null;
  };

  return (
    <div style={{ padding: '24px', maxWidth: '900px', margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
        <div>
          <h1 style={{ fontSize: '24px', fontWeight: 700, color: '#111827', margin: 0 }}>⚙️ Onay Akış Yönetimi</h1>
          <p style={{ color: '#6B7280', marginTop: '4px', fontSize: '14px' }}>Talep türleri için parametrik onay akışları tanımlayın</p>
        </div>
        <button onClick={yeniAc} style={{ background: '#4F46E5', color: '#fff', border: 'none', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer', fontWeight: 600 }}>
          + Yeni Şablon
        </button>
      </div>

      {yukleniyor ? (
        <div style={{ textAlign: 'center', padding: '60px', color: '#9CA3AF' }}>Yükleniyor...</div>
      ) : sablonlar.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '60px', background: '#F9FAFB', borderRadius: '12px', border: '2px dashed #E5E7EB' }}>
          <div style={{ fontSize: '48px', marginBottom: '12px' }}>⚙️</div>
          <p style={{ color: '#6B7280', fontWeight: 600 }}>Henüz onay akışı tanımlanmamış</p>
          <button onClick={yeniAc} style={{ marginTop: '12px', background: '#4F46E5', color: '#fff', border: 'none', padding: '8px 20px', borderRadius: '6px', cursor: 'pointer' }}>İlk şablonu oluştur</button>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          {sablonlar.map(sablon => (
            <div key={sablon.id} style={{ background: '#fff', borderRadius: '12px', border: '1px solid #E5E7EB', overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.05)' }}>
              <div style={{ padding: '16px 20px', borderBottom: '1px solid #F3F4F6', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <span style={{ fontWeight: 700, fontSize: '16px', color: '#111827' }}>{sablon.baslik}</span>
                    <span style={{ background: '#EEF2FF', color: '#4F46E5', fontSize: '11px', padding: '2px 8px', borderRadius: '4px', fontWeight: 700, fontFamily: 'monospace' }}>{sablon.talep_turu}</span>
                    <span style={{ background: sablon.aktif ? '#F0FDF4' : '#FEF2F2', color: sablon.aktif ? '#16A34A' : '#DC2626', fontSize: '11px', padding: '2px 8px', borderRadius: '4px', fontWeight: 600 }}>
                      {sablon.aktif ? 'Aktif' : 'Pasif'}
                    </span>
                  </div>
                  {sablon.aciklama && <p style={{ color: '#6B7280', fontSize: '13px', marginTop: '4px' }}>{sablon.aciklama}</p>}
                </div>
                <button onClick={() => duzenleAc(sablon)} style={{ background: '#EEF2FF', color: '#4F46E5', border: 'none', padding: '7px 16px', borderRadius: '6px', cursor: 'pointer', fontWeight: 600, fontSize: '13px' }}>
                  Düzenle
                </button>
              </div>

              {/* Adımlar */}
              <div style={{ padding: '16px 20px', display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
                {(sablon.adimlar || []).map((adim, idx) => (
                  <React.Fragment key={adim.id}>
                    <div style={{ background: '#F9FAFB', border: '1px solid #E5E7EB', borderRadius: '8px', padding: '10px 14px', minWidth: '140px' }}>
                      <div style={{ fontSize: '10px', fontWeight: 700, color: '#9CA3AF', textTransform: 'uppercase', marginBottom: '4px' }}>Adım {adim.sira}</div>
                      <div style={{ fontSize: '13px', fontWeight: 600, color: '#111827' }}>{adim.baslik}</div>
                      <div style={{ fontSize: '11px', color: '#6B7280', marginTop: '2px' }}>
                        {adim.onaylayan_tur === 'rol' ? `Rol: ${adim.onaylayan_deger}` : adim.onaylayan_deger}
                      </div>
                    </div>
                    {idx < sablon.adimlar.length - 1 && (
                      <div style={{ color: '#9CA3AF', fontSize: '18px' }}>→</div>
                    )}
                  </React.Fragment>
                ))}
                {(!sablon.adimlar || sablon.adimlar.length === 0) && (
                  <span style={{ color: '#9CA3AF', fontSize: '13px' }}>Adım tanımlanmamış</span>
                )}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Modal */}
      {modalAcik && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: '16px', padding: '32px', width: '100%', maxWidth: '640px', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 25px 50px rgba(0,0,0,0.25)' }}>
            <h2 style={{ fontSize: '20px', fontWeight: 700, margin: '0 0 24px' }}>
              {secili ? '✏️ Şablon Düzenle' : '+ Yeni Onay Şablonu'}
            </h2>

            {hata && <div style={{ background: '#FEF2F2', color: '#DC2626', padding: '10px 14px', borderRadius: '8px', marginBottom: '16px', fontSize: '14px' }}>⚠️ {hata}</div>}
            {basari && <div style={{ background: '#F0FDF4', color: '#16A34A', padding: '10px 14px', borderRadius: '8px', marginBottom: '16px', fontSize: '14px' }}>✅ {basari}</div>}

            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                <div>
                  <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Talep Türü * <span style={{ color: '#9CA3AF', fontWeight: 400 }}>(benzersiz anahtar)</span></label>
                  <input value={form.talep_turu} onChange={e => setForm(f => ({ ...f, talep_turu: e.target.value.toLowerCase().replace(/\s/g,'-') }))}
                    placeholder="örn: izin, masraf, zimmet"
                    disabled={!!secili}
                    style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', fontFamily: 'monospace', boxSizing: 'border-box', background: secili ? '#F9FAFB' : '#fff' }} />
                </div>
                <div>
                  <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Başlık *</label>
                  <input value={form.baslik} onChange={e => setForm(f => ({ ...f, baslik: e.target.value }))}
                    placeholder="örn: İzin Talebi Onayı"
                    style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }} />
                </div>
              </div>

              <div>
                <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Açıklama</label>
                <input value={form.aciklama} onChange={e => setForm(f => ({ ...f, aciklama: e.target.value }))}
                  placeholder="İsteğe bağlı açıklama"
                  style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }} />
              </div>

              {/* Adımlar */}
              <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                  <label style={{ fontSize: '13px', fontWeight: 700, color: '#374151' }}>Onay Adımları</label>
                  <button onClick={adimEkle} style={{ background: '#EEF2FF', color: '#4F46E5', border: 'none', padding: '6px 14px', borderRadius: '6px', cursor: 'pointer', fontWeight: 600, fontSize: '13px' }}>+ Adım Ekle</button>
                </div>

                {form.adimlar.map((adim, idx) => (
                  <div key={idx} style={{ background: '#F9FAFB', border: '1px solid #E5E7EB', borderRadius: '10px', padding: '14px', marginBottom: '10px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                      <span style={{ fontWeight: 700, fontSize: '13px', color: '#4F46E5' }}>Adım {adim.sira}</span>
                      {form.adimlar.length > 1 && (
                        <button onClick={() => adimSil(idx)} style={{ background: '#FEF2F2', color: '#DC2626', border: 'none', padding: '4px 10px', borderRadius: '5px', cursor: 'pointer', fontSize: '12px' }}>Sil</button>
                      )}
                    </div>

                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                      <div>
                        <label style={{ fontSize: '12px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '4px' }}>Adım Adı *</label>
                        <input value={adim.baslik} onChange={e => adimGuncelle(idx, 'baslik', e.target.value)}
                          placeholder="örn: Yönetici Onayı"
                          style={{ width: '100%', padding: '8px 10px', border: '1.5px solid #E5E7EB', borderRadius: '6px', fontSize: '13px', boxSizing: 'border-box' }} />
                      </div>
                      <div>
                        <label style={{ fontSize: '12px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '4px' }}>Onaylayan Türü</label>
                        <select value={adim.onaylayan_tur} onChange={e => adimGuncelle(idx, 'onaylayan_tur', e.target.value)}
                          style={{ width: '100%', padding: '8px 10px', border: '1.5px solid #E5E7EB', borderRadius: '6px', fontSize: '13px', boxSizing: 'border-box' }}>
                          {ONAYLAYAN_TURLER.map(t => <option key={t.deger} value={t.deger}>{t.etiket}</option>)}
                        </select>
                      </div>
                      {adim.onaylayan_tur !== 'pozisyon_ustu' && (
                        <div>
                          <label style={{ fontSize: '12px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '4px' }}>Onaylayan *</label>
                          <select value={adim.onaylayan_deger} onChange={e => adimGuncelle(idx, 'onaylayan_deger', e.target.value)}
                            style={{ width: '100%', padding: '8px 10px', border: '1.5px solid #E5E7EB', borderRadius: '6px', fontSize: '13px', boxSizing: 'border-box' }}>
                            <option value="">— Seçin —</option>
                            {onaylayandegerSecenekleri(adim.onaylayan_tur)}
                          </select>
                        </div>
                      )}
                      {adim.onaylayan_tur === 'pozisyon_ustu' && (
                        <div style={{ background: '#EEF2FF', borderRadius: '6px', padding: '8px 12px', fontSize: '12px', color: '#4F46E5', fontWeight: 600 }}>
                          ✓ Org ağacındaki üst pozisyon kişisi otomatik bulunur
                        </div>
                      )}
                      <div>
                        <label style={{ fontSize: '12px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '4px' }}>Red Durumunda</label>
                        <select value={adim.red_durumunda} onChange={e => adimGuncelle(idx, 'red_durumunda', e.target.value)}
                          style={{ width: '100%', padding: '8px 10px', border: '1.5px solid #E5E7EB', borderRadius: '6px', fontSize: '13px', boxSizing: 'border-box' }}>
                          <option value="iptal">Talebi İptal Et</option>
                          <option value="revize">Revize İste</option>
                        </select>
                      </div>
                    </div>

                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '10px', cursor: 'pointer' }}>
                      <input type="checkbox" checked={adim.zorunlu} onChange={e => adimGuncelle(idx, 'zorunlu', e.target.checked)} />
                      <span style={{ fontSize: '12px', color: '#374151' }}>Zorunlu adım</span>
                    </label>
                  </div>
                ))}
              </div>
            </div>

            <div style={{ display: 'flex', gap: '12px', marginTop: '24px' }}>
              <button onClick={() => setModalAcik(false)} style={{ flex: 1, padding: '11px', borderRadius: '8px', border: '1.5px solid #E5E7EB', background: '#fff', cursor: 'pointer', fontWeight: 600 }}>İptal</button>
              <button onClick={kaydet} style={{ flex: 2, padding: '11px', borderRadius: '8px', border: 'none', background: '#4F46E5', color: '#fff', cursor: 'pointer', fontWeight: 600, fontSize: '14px' }}>
                {secili ? 'Güncelle' : 'Oluştur'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
